import { Component, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-setup-success",
  templateUrl: "./app-setup-success.component.html",
})
export class AppSetupSuccessComponent {
  @Output() sendCode = new EventEmitter<any>();

  constructor() {
  }

  public sendVerificationCode() {
    this.sendCode.emit();
  }
}
